// Module-level bridge so non-React code (e.g. the axios response interceptor
// in services/http.js) can fire toasts without going through the React tree.
//
// NotificationProvider registers its handlers on mount; consumers call
// notify.error() / notify.warning() / etc and the bridge fans out to
// whichever handlers are currently registered.
//
// If no handler is registered yet (e.g. an error fires before the provider
// mounts), the call falls back to console.* so the error isn't silently lost.

let handlers = {
  success: null,
  error: null,
  info: null,
  warning: null,
};

export const setNotificationHandlers = (next) => {
  handlers = {
    success: typeof next?.success === 'function' ? next.success : null,
    error:   typeof next?.error   === 'function' ? next.error   : null,
    info:    typeof next?.info    === 'function' ? next.info    : null,
    warning: typeof next?.warning === 'function' ? next.warning : null,
  };
};

export const clearNotificationHandlers = () => {
  handlers = { success: null, error: null, info: null, warning: null };
};

const fire = (level, message, opts) => {
  if (handlers[level]) {
    handlers[level](message, opts);
    return;
  }
  // Fallback when no provider is mounted yet (e.g. boot-time error)
  // eslint-disable-next-line no-console
  console[level === 'error' ? 'error' : level === 'warning' ? 'warn' : 'log'](`[notify.${level}]`, message);
};

export const notify = {
  success: (message, opts) => fire('success', message, opts),
  error:   (message, opts) => fire('error',   message, opts),
  info:    (message, opts) => fire('info',    message, opts),
  warning: (message, opts) => fire('warning', message, opts),
};
